import { useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TicketsDashboard from "../components/dashboard/TicketsDashboard";
import Footer from "../components/Footer";
import { logout } from "../services/api";
import { safeLocalStorageGet } from "../utils/safeJsonParse";

/**
 * Capitalizes the first letter of each word in a string.
 */
function formatName(name) {
  return name
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export default function StaffHomePage() {
  const [profile] = useState(() => safeLocalStorageGet("staff_profile", null));

  const handleLogout = async () => {
    const token = localStorage.getItem("staff_token");
    const refreshToken = localStorage.getItem("staff_refresh_token");
    await logout(token, refreshToken);
  };

  const rawName = profile
    ? `${profile.firstname} ${profile.lastname}`
    : "Tunde Usman";
  const displayName = formatName(rawName);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <Navbar userName={displayName} onLogout={handleLogout} />
      <Hero userName={displayName} />
      <TicketsDashboard userName={displayName} />
      <Footer />
    </div>
  );
}
